// web/src/index.ts
// 首页（落地页）：文案走 i18n 的 data-i18n 声明式属性，这里只负责
// 渲染「七款乐器」列表 —— 每张卡片直接链接到该乐器的 Quick Start 页面。
import { getLang, initI18n } from "./i18n";
import { pickText, PRODUCT_META } from "./site-data";
import { productMark, productThumb } from "./product-visual";

function escapeHtml(s: string): string {
  return s.replace(
    /[&<>"']/g,
    (c) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[
        c
      ] as string,
  );
}

function renderInstruments(): void {
  const lang = getLang();
  const isZh = lang === "zh";
  const root = document.getElementById("home-instruments");
  if (!root) return;
  root.innerHTML = "";

  PRODUCT_META.forEach((p) => {
    const name = pickText(p.title, lang);
    const card = document.createElement("a");
    card.className = "instrument-card";
    card.href = `/quickstart/${p.slug}.html`;
    card.dataset.slug = p.slug;
    // 缩略图用 480×270 的小图（横幅原图 1376×768、500KB 以上，压到 190px 显示
    // 既浪费带宽又不可能更清楚）。亮度在出图时已经提过，CSS 里不再挂 filter。
    card.innerHTML = `
      <img
        class="instrument-thumb"
        src="${productThumb(p.key)}"
        alt="${escapeHtml(name)}${isZh ? " 演奏预览" : " performance preview"}"
        width="480"
        height="270"
        loading="lazy"
        decoding="async"
      />
      <p>
        ${productMark(p.key)}
        <span>${escapeHtml(name)}</span>
        <span class="chip free">${isZh ? "免费可用" : "Free to use"}</span>
      </p>
      <span class="instrument-cta">${
        isZh ? "进入 Quick Start →" : "Open Quick Start →"
      }</span>
    `;
    root.appendChild(card);
  });
}

function main(): void {
  initI18n();
  renderInstruments();
  document.addEventListener("langchange", renderInstruments);
}

main();
